import React, { useRef } from "react";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Constant from "../../Constant";
import Apa1 from "../../Assets/images/apa1.png";

function ActiveFinancedCarousel({ items = [], onCardClick }) {
  const scrollContainerRef = useRef(null);

  const handleScroll = (direction) => {
    if (scrollContainerRef.current) {
      const scrollAmount = 380;
      scrollContainerRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="mb-6 relative group">
      <div className="flex justify-between items-center mb-2.5">
        <p className="text-[#808285] text-[14px] font-[700]">Active Financed</p>
        <div className="flex gap-1">
          <button
            onClick={() => handleScroll("left")}
            className="w-6 h-6 rounded-full bg-white border border-gray-200 flex items-center justify-center text-gray-500 hover:bg-gray-50 hover:text-black transition shadow-xs cursor-pointer"
            aria-label="Previous"
          >
            <ChevronLeftIcon sx={{ fontSize: 18 }} />
          </button>
          <button
            onClick={() => handleScroll("right")}
            className="w-6 h-6 rounded-full bg-white border border-gray-200 flex items-center justify-center text-gray-500 hover:bg-gray-50 hover:text-black transition shadow-xs cursor-pointer"
            aria-label="Next"
          >
            <ChevronRightIcon sx={{ fontSize: 18 }} />
          </button>
        </div>
      </div>

      <div
        ref={scrollContainerRef}
        className="flex gap-4 overflow-x-auto pb-2 scrollbar-none scroll-smooth"
        style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
      >
        {items.map((item) => (
          <div
            key={item.id}
            onClick={() => onCardClick && onCardClick(item)}
            className="bg-white rounded-l-[20px] rounded-r-none border border-[#F1F5F9] hover:shadow-[#00BC67] transition-all duration-200 overflow-hidden flex items-stretch flex-shrink-0 w-[360px] md:w-[385px] h-[122px] cursor-pointer"
          >
            <div className="w-[135px] md:w-[145px] h-full flex-shrink-0 bg-gray-100 overflow-hidden">
              <img
                src={item.image || Apa1}
                alt={item.title}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex-1 p-3.5 flex flex-col justify-between min-w-0">
              <div>
                <p className="text-[#000000] font-[700] text-[14px] md:text-[13px]">
                  {item.title}
                </p>
                <p className="text-[#999FA9] text-[10px] font-[400] flex items-center gap-1 mt-1">
                  <PlaceOutlinedIcon
                    sx={{ fontSize: 15, color: "#1E222B", flexShrink: 0 }}
                  />
                  <span className="">{item.location}</span>
                </p>
              </div>

              <div className="flex items-center justify-between gap-2 mt-auto pt-1">
                <span
                  className={`text-[12px] font-bold text-center px-3.5 py-1 rounded-[6px] text-white flex-shrink-0 ${item.type?.toLowerCase() === "land" ? "bg-[#76D400]" : "bg-[#0088FF]"}`}
                >
                  {item.type}
                </span>
                <span className="text-[#1E222B] font-[700] text-[14px] flex-shrink-0">
                  ₦ {Constant.FormatNumber(item.price)}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ActiveFinancedCarousel;
